var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle134(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.407,
    height: 179.407,
    viewBox: "0 0 179.407 179.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-134",
    transform: "matrix(0.438, 0.899, -0.899, 0.438, 120.591, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.085,
    cy: 67.085,
    rx: 67.085,
    ry: 67.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.085,
    cy: 67.085,
    rx: 66.585,
    ry: 66.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    transform: "translate(126.103 38.871)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.494,
    cy: 3.494,
    rx: 3.494,
    ry: 3.494,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.494,
    cy: 3.494,
    rx: 2.994,
    ry: 2.994,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle134);
export default __webpack_public_path__ + "static/media/circle-134.c803b90e036d8d2cbb8f659ea496d43f.svg";
export { ForwardRef as ReactComponent };